import { Spinner } from "../atoms/Spinner";
import Plans from "../Plans";
import { ModalShell } from "../atoms/ModalShell";
import useAuth from "../../hooks/useAuth";
import { useTranslation } from "react-i18next";

import { CustomButton } from "../atoms/CustomButton";
import { useGetOwnerPlans } from "../../hooks/billing";
import { PlanTier, usePermissions } from "../../utils/permissions";

export const PlansModal = ({
  showPlansModal,
  setShowPlansModal,
  title,
  hideFooter = false,
  onCloseModal,
  targetPlan,
}: {
  showPlansModal: boolean;
  setShowPlansModal: (value: boolean) => void;
  title?: string;
  hideFooter?: boolean;
  onCloseModal?: () => void;
  targetPlan?: PlanTier;
}) => {
  const { t } = useTranslation();
  const { customer_identification, user } = useAuth();
  const permissions = usePermissions(user);
  const borrowsOwnerPlan = user.borrows_owner_plan === true;
  const isTeamMember = borrowsOwnerPlan || permissions.isRoleGoverned();
  const { isLoading, isError, isSuccess, refetch } = useGetOwnerPlans(
    customer_identification,
    user.entity_identification,
    isTeamMember
  );

  const handleClose = () => {
    setShowPlansModal(false);
    onCloseModal?.();
  };

  const plans = (
    <Plans
      user_identification={customer_identification}
      entity_identification={user.entity_identification}
      isInBilling={!hideFooter}
      onCloseModal={handleClose}
      targetPlan={targetPlan}
    />
  );

  let content;
  if (isTeamMember) {
    content = plans;
  } else if (isLoading) {
    content = (
      <span translate="no">
        <Spinner size="sm" />
      </span>
    );
  } else if (isError) {
    content = (
      <CustomButton
        onClick={() => refetch()}
        title={t("dashboard.billings.btn-05") as string}
      />
    );
  } else if (isSuccess) {
    content = plans;
  }
  return (
    <ModalShell
      show={showPlansModal}
      onClose={handleClose}
      size="7xl"
      title={title}
      bareCloseButton
      footer={
        !hideFooter ? (
          <CustomButton
            title={t("common.close") as string}
            onClick={handleClose}
            variant="primary"
          />
        ) : undefined
      }
    >
      {content}
    </ModalShell>
  );
};
